'use client';

import React from 'react'
import { useInView } from '@/lib/useInView'

interface HeadingProps {
  title?: string
  body?: string
  showTitle?: boolean
  showHr?: boolean
  className?: string
  disableAnimation?: boolean
  headingId?: string
}

export default function HeadingCentered({ title, showTitle = true, className = "", disableAnimation = false, headingId }: HeadingProps) {
  const { ref } = useInView<HTMLDivElement>();
  
  return (
    <>
      <div 
        ref={disableAnimation ? undefined : ref} 
        className={`heading-centered max-w-120rem mx-auto global-padding ${!disableAnimation ? 'animate-in-view' : ''} ${className}`}
      >
        {showTitle && title && <h2 id={headingId} className="heading-4 text-center">{title}</h2>}
      </div>
    </>
  )
}
